import {h, Fragment} from "preact"
import { useMemo } from 'preact/hooks';

function Review({ count, score }) {
   //console.log('Review -> count', count, 'score', score);
   
   let parsedScore = null;

   try {
     const parsed = JSON.parse(score);
     parsedScore = parsed.value ?? null;
   } catch (e) {
     parsedScore = score; // fallback if not JSON
   }

  const reviewData = useMemo(() => {
    const roundedScore = Math.round(parsedScore * 2) / 2;
    const fullStars = Math.floor(roundedScore);
    const halfStars = roundedScore % 1 !== 0 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;

    return {
      roundedScore,
      fullStars,
      halfStars,
      emptyStars,
    };
  }, [score]);

//   console.log('Review -> reviewData', reviewData);

  if (!count || !score || count === 0) return null;
  return (
    <>
      <div
        class="jdgm-prev-badge"
        data-average-rating={parsedScore}
        data-number-of-reviews=""
        data-number-of-questions="0"
      >
        <span
          class="jdgm-prev-badge__stars"
          data-score={parsedScore}
          tabindex="0"
          aria-label={`${parsedScore} stars`}
          role="button"
        >
          {Array(reviewData.fullStars)
            .fill()
            .map((_, index) => (
              <span
                key={index}
                class="jdgm-star jdgm--on"
              ></span>
            ))}
          {Array(reviewData.halfStars)
            .fill()
            .map((_, index) => (
              <span
                key={index}
                class="jdgm-star jdgm--half"
              ></span>
            ))}
          {Array(reviewData.emptyStars)
            .fill()
            .map((_, index) => (
              <span
                key={index}
                class="jdgm-star jdgm--off"
              ></span>
            ))}
        </span>
        <span class="jdgm-prev-badge__text">{` ${count} `}</span>
      </div>
    </>
  );
}

export default Review;
